import React, {Component, PropTypes, cloneElement} from 'react';
import {Col, Row, Container} from 'src/components/Common/reactstrap/lib';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import styles from 'src/components/Catalog/Catalog.scss';
import * as actions from './redux/userAction';
import carImg from 'src/imgs/car/default-car.jpg';
import {Link} from 'react-router';
import config from '../../config';
import Breadcrumbs from 'src/components/Breadcrumbs/Breadcrumbs';
import {getIdByURL} from 'src/logic/utils';
import GarageModalAddCar from './elements/GarageModalAddCar';
import CarBrandList from './elements/GarageCarBrandList';
import GarageModalDelete from './elements/GarageModalDelete';
import GarageSaveCar from './elements/GarageSaveCar';
import {sortBy} from 'lodash';

import InlineSVG from 'react-svg-inline';

import deleteIcon from 'src/imgs/canbin.svg';
import editIcon from 'src/imgs/edit.svg';

import {browserHistory} from 'react-router';

export class Garage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalElement: null,
      modal: false,
      garageToDeleteId: null,
      garageToEdit: null
    };
    this.startModal = this.startModal.bind(this);
    this.updateGarage = this.updateGarage.bind(this);
    this.cancelEditGarage = this.cancelEditGarage.bind(this);
    this.confirmDeleteGarage = this.confirmDeleteGarage.bind(this);
    this.cancelDeleteGarage = this.cancelDeleteGarage.bind(this);
  }

  componentWillMount() {
    this.props.getUserGarage();
  }

  componentWillReceiveProps(props) {

    this.setState({
      modalElement: props.children && React.cloneElement(props.children),
    });
    if (getIdByURL() == 'garage?status=done') this.startModal();
  }

  startModal() {
    if (this.state.modal && getIdByURL() != 'garage') {
      this.setState({
        modalElement: null
      });
      browserHistory.replace({pathname: '/garage'})

    }

    this.setState({
      modal: !this.state.modal
    });
  }

  updateGarage(garage) {
    this.setState({
      garageToEdit: Object.assign({}, garage)
    });
  }

  cancelEditGarage() {
    this.setState({
      garageToEdit: null
    });
  }


  confirmDeleteGarage(id) {
    this.setState({
      garageToDeleteId: id
    });
  }

  cancelDeleteGarage() {
    this.setState({
      garageToDeleteId: null
    });
  }

  renderModelList() {
    if (!this.props.Garage)
      return (<div/>);
    const garage = sortBy(this.props.Garage, ['GarageId']);
    return garage.map((garage) => {
      return (
        <Col sm="4" key={garage.GarageId}>
          <Row>
            <Col sm="4">
              <img src={garage.Model.ImgUrl} onError={(e) => e.target.src = carImg}/>
              <div className="svg-control">
                <InlineSVG
                  onClick={() => this.updateGarage(garage)}
                  svg={editIcon}/>
                <InlineSVG
                  onClick={() => this.confirmDeleteGarage(garage.GarageId)}
                  svg={deleteIcon}/>
              </div>
            </Col>
            <Col sm="8" className="text-bold custom-media">
              <p> {garage.Brand.BrandName} {garage.Model.ModelName}</p>
              <span
                className="text-muted">{garage.Model.ModelYearStart + ' - '}{garage.Model.ModelYearEnd ? (garage.Model.ModelYearEnd) : 'наст. время'}</span>
              <p>VIN: {garage.VIN}</p>
              <p>Пробег: {garage.Mileage}</p>
              <p><Link  to={'/components/' + garage.Modification.ModificationId} className="link"> Каталог оригинальных запчастей</Link></p>
              <p><Link  to={'#'} className="link">Запчасти для ТО</Link></p>
            </Col>
          </Row>
        </Col>
      );
    });
  }

  render() {
    let modalElement = this.state.modalElement,
      title = 'Выберите марку', //params
      deleteGarageVisible = this.state.garageToDeleteId ? true : false,
      editGarageVisible = this.state.garageToEdit ? true : false;
    if (modalElement) {
      switch (modalElement.props.route.path) {
        case '/garage/:brand':
          title = 'Выберите модель';
          break;
        case '/garage/:brand/:modelId':
          title = 'Выберите модификацию';
          break;
        case '/garage-set/:modificationId':
          title = 'Укажите VIN-номер и пробег';
          break;
        default:
          console.log(modalElement.props.route.path); // for debug
      }
    }

    return (
      <Container>
        {!modalElement && getIdByURL() === 'garage' && <Breadcrumbs
          routes={this.props.routes}/> }
        <h2>Гараж</h2>
        <Row>
          <Col sm={{size: 3, pull: 6, offset: 6}} className="m-b-2">
            <GarageModalAddCar
              buttonLabel="Добавить автомобиль"
              className="modal-wide"
              startModal={this.startModal}
              modal={this.state.modal}
              modalTitle={title}
              modalBody={
                modalElement ||
                <CarBrandList/>
              }
            />

          </Col>
          {this.renderModelList()}
          <GarageModalAddCar
            buttonLabel={null}
            className="modal-wide"
            modal={editGarageVisible}
            startModal={this.cancelEditGarage}
            modalTitle="Редактировать"
            modalBody={
              <GarageSaveCar car={this.state.garageToEdit} startModal={this.cancelEditGarage}/>
            }
          />
          <GarageModalDelete
            className="modal-delete"
            visible={deleteGarageVisible}
            close={this.cancelDeleteGarage}
            garageToDeleteId={this.state.garageToDeleteId}
            deleteGarage={this.props.deleteUserGarage}
          />
        </Row>

      </Container>
    );
  }
}

Garage.routeTitle = "Гараж";

export default connect(
  (state) => ({...state.userReducer}),
  (dispatch) => ({...bindActionCreators(actions, dispatch)})
)(Garage);



/** WEBPACK FOOTER **
 ** ./src/components/User/Garage.jsx
 **/